export default __webpack_public_path__ + "static/media/KvOverviewBg.ecdd205d.jpg";